module.exports = __webpack_public_path__ + "static/media/doremi_titlescreen.ab259ff3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/doremi_titlescreen.gif
// module id = 237
// module chunks = 0